import TOS from './index.vue'

export default {
    path: '/tos',
    name: 'tos',
    component: TOS,
    meta: { title: 'dashboard_v2.titles.terms_and_conditions' },
}
